import { pushGtmEvent } from '@/src/analytics/gtm'
import { selectClevertapProfile } from '@/src/redux/slices/authSlice'
import { useAppSelector } from '@/src/redux/store'
import { getDeviceType } from '@/src/utils/api/getDeviceType'
import { getUserAuthValues } from '@/src/utils/auth'
import { getUserSelectedCurrencyCode } from '@/src/utils/currency/getCurrencyCode'
import { getPlatformName } from '@/src/utils/deviceType'
import { isUserSignedIn } from '@/src/utils/generalUtils/checkUserLogin'
import { useLocale } from 'next-intl'

const useOffersGtmEvent = () => {
    const locale = useLocale()
    const isSignedIn = isUserSignedIn()
    const { email } = getUserAuthValues() || {}
    const clevertapProfile = useAppSelector(selectClevertapProfile)
    const hostname = typeof window !== 'undefined' ? window.location.hostname : ''
    const deviceType = getDeviceType()
    const platform = getPlatformName(deviceType)?.toLowerCase()

    // Attributes common to every offers-hook event (per the GA Events sheet) —
    // mirrors the homepage hook's commonBase.
    const commonBase = {
        user_domain: hostname,
        platform,
        user_email: email ? email.toLowerCase() : 'not_informed',
        is_user_logged_in: isSignedIn ? 'yes' : 'no',
        user_language: locale,
        user_currency: getUserSelectedCurrencyCode()?.toUpperCase() || 'not_informed',
        product_category: 'flights',
        user_phone: clevertapProfile?.Phone || 'not_informed'
    }

    // page_view_offers (8 attributes) — offers listing page
    const pushOffersPageViewEvent = () => {
        pushGtmEvent({ event: 'page_view_offers', ...commonBase })
    }

    // page_view_offer_details (9 attributes) — single offer page, adds slug_name
    const pushOfferDetailsPageViewEvent = (offerSlug: string) => {
        pushGtmEvent({ event: 'page_view_offer_details', ...commonBase, slug_name: offerSlug })
    }

    return {
        pushOffersPageViewEvent,
        pushOfferDetailsPageViewEvent
    }
}

export default useOffersGtmEvent
